import React, {useState} from 'react'
import * as S from './styled'
import {AlertDialog} from "../index";
import ActionDialog from '../action-dialog'
import i18n from "../../../assets/i18n";
import {assignJobOfferToCandidates} from "../../../api";
import {useAssignJobOffersOptions} from "../../../api/queries/useJobOffers";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {useAppContext} from "../../../context/appContext";
import {ALERT_LEVEL} from "../../../config/constants";

const AssignJobOfferButton = ({ ids, totalRows, setRowsSelected, tableRef}) => {

  const {createAlert} = useAppContext();
  const [open, setOpen ] = useState(false)
  const [areUSure, setAreUSure ] = useState(false)
  const [offerId, setOfferId] = useState(null);
  const {data: jobOfferAssignOptions} = useAssignJobOffersOptions();

  const handleSubmit = e => {
    e.preventDefault();
    if (!offerId || !ids || ids.length === 0) {
      return;
    }
    if (!areUSure) {
      setAreUSure(true);
      return;
    }

    // Devuelve la promesa: spinner en la confirmación y los modales se cierran cuando responde bien
    /* eslint-disable no-useless-computed-key */
    return assignJobOfferToCandidates({offer_id: offerId, ids} ).then(() => {
      setAreUSure(false);
      setOpen(false);
      setOfferId(null);
      setRowsSelected([]);
      tableRef.current && tableRef.current.onAllSelected(false);
      createAlert(i18n.assignJobOfferModal.successfully_assigned, ALERT_LEVEL.SUCCESS);
    });
  }

  return (
    <>
      <ActionDialog
        open={open}
        title={i18n.assignJobOfferModal.title}
        onClose={()=>setOpen(false)}
        onConfirm={handleSubmit}
        cancelLabel={i18n.dialog.decline}
        confirmLabel={i18n.assignJobOfferModal.assign}
        confirmDisabled={!offerId}
        disableBackdropClose
      >
        <S.ModalStyled>
          <form onSubmit={handleSubmit}>
            <label>{i18n.assignJobOfferModal.offer}</label>
            <Autocomplete
              className='autocomplete-custom'
              options={jobOfferAssignOptions}
              getOptionLabel={(option) => option.internalName}
              onChange={(_, value) => {
                setOfferId(value ? value.id : "");
              }}
              renderInput={(params) => (
                <TextField {...params} placeholder={i18n.assignJobOfferModal.offer_placeholder} variant="outlined"/>
              )}
            />

            <AlertDialog
              open={areUSure}
              onClose={() => setAreUSure(false)}
              onSuccess={(e) => handleSubmit(e)}
              title={i18n.process.deleteModalTitle}
              text={i18n.assignJobOfferModal.areUSure.description.replaceAll('{num}', (ids && ids.length > 0) ? ids.length : totalRows)}
            />
          </form>
        </S.ModalStyled>
      </ActionDialog>
      <S.ButtonExport
        variant="contained"
        color="secondary"
        onClick={() => setOpen(true)}
        disabled={!ids || ids.length === 0}
      >
        {i18n.assignJobOfferModal.button_title} ({(ids) ? ids.length : "0"})
      </S.ButtonExport>
    </>
  )
}

export default AssignJobOfferButton